import {useEffect} from 'react'
import { Typography } from 'antd';
import Loading from './Loading';
const { Title, Link } = Typography;

const Activity = () => { 
  useEffect(() => {
    setTimeout(() => {
        window.location.href = " https://v.douyin.com/_AWD7Hxcp5U/";
    }, 2000)
  }, []);
  // 渲染数据
  return (
    <>
      <Title level={3} style={{ margin: "15px 0", flex: 1 }}>
        稍等喵~正在快速到达~!!
        <Loading />
      </Title>
    </>
  );
};

export default Activity;
